import tinycolor from 'tinycolor2'

export default function getTintsAndShades(adjustment, color) {
  const mixes = {
    tint: 'white',
    shade: 'black',
  }

  if (!mixes[adjustment])
    return []

  return [20, 40, 60, 80].map(i => tinycolor.mix(color, mixes[adjustment], i).toHexString())
}
